import { Loader } from "@clearhaus/design-system"
import React, { useEffect, useRef, useState } from "react"
import { RouteComponentProps } from "react-router-dom"
import { Subscription } from "rxjs"
import { map, pluck } from "rxjs/operators"

import { useAccountHelpers } from "../../hooks/useAccountHelpers"
import { useAccounts } from "../../modules/accounts/hooks/useAccounts"
import { useRoot } from "../../modules/root"
import NotFound from "../NotFound"

interface IAccountRedirectMatch {
    id: string
    tabKey?: "contract"
}

export const Account: React.FC<RouteComponentProps<IAccountRedirectMatch>> = (props) => {
    const { match } = props
    const root = useRoot()
    const [notFound, setNotFound] = useState(() => {
        return !root.accounts
    })
    const accountsSub = useRef<Subscription>()
    const accounts = useAccounts(root.accounts, 1, 1, `id:${match.params.id}`)
    const { navigateToContract, navigateTo } = useAccountHelpers()

    useEffect(() => {
        accountsSub.current = accounts
            .pipe(
                pluck("relations"),
                map((relations) => {
                    if (!relations) {
                        return null
                    }
                    if (!relations.accounts) {
                        return []
                    }

                    return Array.isArray(relations.accounts)
                        ? relations.accounts
                        : [relations.accounts]
                })
            )
            .subscribe((accountUris) => {
                if (accountUris) {
                    if (accountUris.length === 0) {
                        setNotFound(true)
                    } else {
                        const accountUri = accountUris[0]
                        if (!match.params.tabKey) {
                            navigateTo(accountUri, true)
                        } else if (match.params.tabKey === "contract") {
                            navigateToContract(accountUri, true)
                        }
                    }
                }
            })

        return () => {
            if (accountsSub.current && !accountsSub.current.closed) {
                accountsSub.current.unsubscribe()
            }
        }
    }, [])

    return (
        <>
            {!notFound && <Loader size={32} />}
            {notFound && <NotFound />}
        </>
    )
}
